module.exports = "/images/vendor/flag-icon-css/flags/1x1/tj.svg?980d12c941054162ab1802ce9635ec37";